import { Injectable } from "@angular/core";
import {
  Http,
  ConnectionBackend,
  RequestOptions,
  RequestOptionsArgs,
  Request,
  RequestMethod,
  Headers,
  Response,
} from "@angular/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class CustomHttpService extends Http {
  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof url === "string") {
      const requestOptions = this.ensureAuthHeader(options, url);
      return super.request(url, requestOptions);
    }

    const requestUrl = url && url.url ? url.url : "";
    if (this.shouldSkipAuth(requestUrl)) {
      return super.request(url);
    }

    const token = localStorage.getItem("authtoken");
    if (token) {
      if (!url.headers) {
        url.headers = new Headers();
      }
      if (!url.headers.has("Authorization")) {
        url.headers.set("Authorization", token);
      }
    }
    return super.request(url);
  }

  private ensureAuthHeader(options: RequestOptionsArgs | undefined, url: string): RequestOptionsArgs {
    const requestOptions: RequestOptionsArgs = options || {};
    if (this.shouldSkipAuth(url)) {
      return requestOptions;
    }

    const token = localStorage.getItem("authtoken");
    if (!token) {
      return requestOptions;
    }

    const headers = requestOptions.headers || new Headers();
    if (!headers.has("Authorization")) {
      headers.set("Authorization", token);
    }
    requestOptions.headers = headers;
    return requestOptions;
  }

  private shouldSkipAuth(url: string): boolean {
    return typeof url === "string" && url.indexOf("/authenticateadmin") !== -1;
  }
}

